import BookRow from "components/Bookcards/BookRow/BookRow";
import Text from "hardcover-ui/components/Text";
import {
  BookSerializersBookByline,
  EditionSerializersEditionByline,
  LetterbooksSerializersBook,
} from "types/serializers";

export interface Props {
  book: BookSerializersBookByline | LetterbooksSerializersBook;
  edition?: EditionSerializersEditionByline;
  rank: number;
  size: "sm" | "md" | "lg";
  className?: string;
  referrerUserId?: number;
  children?: React.ReactNode;
}

export default function BookRowRanked({
  book,
  edition,
  size,
  rank,
  className,
  children = null,
  referrerUserId,
}: Props) {
  return (
    <div
      className={`flex flex-col md:flex-row space-x-2 max-w-screen ${className}`}
    >
      <Text
        variant="title"
        className="pl-2 md:pl-0 md:w-12 flex-none md:text-right text-lg md:text-2xl"
        as="p"
      >
        #{rank}
      </Text>
      <BookRow
        book={book as unknown as BookSerializersBookByline}
        edition={edition}
        size={size}
        referrerUserId={referrerUserId}
        settings={{
          linkContributions: true,
        }}
      >
        {children}
      </BookRow>
    </div>
  );
}
